import { Button, DivButton } from "@/components/ui/button";
import { CopyButton } from "@/components/ui/copy-button";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { RefreshIcon } from "@heroicons/react/outline";

interface CellActionsProps {
  onRetry?: () => void;
  isRetryLoading?: boolean;
  showRetry?: boolean;
  plLinkUrl?: string;
  copyText?: string;
  showCopy?: boolean;
  className?: string;
}

export const CellActions = ({
  onRetry,
  isRetryLoading = false,
  showRetry = true,
  plLinkUrl,
  copyText,
  showCopy = true,
  className = "",
}: CellActionsProps) => {
  const copyButton = showCopy && copyText && (
    <DivButton
      variant="outline"
      size="tinyIcon"
      className="-mt-1"
      isLoading={false}
    >
      <CopyButton text={copyText || ""} />
    </DivButton>
  );

  const plLinkButton = plLinkUrl && (
    <a href={plLinkUrl} target="_blank" rel="noreferrer" className="flex">
      <BasicTooltip content="Go to request" side="top">
        <Button size="tinyIcon" variant="outline" className="-mt-1">
          🍰
        </Button>
      </BasicTooltip>
    </a>
  );

  const retryButton = showRetry && onRetry && (
    <DivButton
      size="tinyIcon"
      variant="outline"
      className="-mt-1"
      onClick={onRetry}
      isLoading={isRetryLoading}
    >
      <BasicTooltip content="Retry" side="top" offset={5}>
        <RefreshIcon className="h-4 w-4 cursor-pointer text-gray-600 hover:text-gray-700" />
      </BasicTooltip>
    </DivButton>
  );

  return (
    <div
      className={`sticky right-0 top-2 z-10 mr-2 flex h-0 justify-end gap-x-1 overflow-visible opacity-0 transition-opacity duration-200 group-hover/Cell:opacity-100 ${className}`}
    >
      {copyButton}
      {plLinkButton}
      {retryButton}
    </div>
  );
};
